import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Company } from '../../../models/company';
import { AlertaService } from "../../../services/alerta.service";
import { CompanyService } from "../../../services/company.service";
import { ActivatedRoute, Router } from '@angular/router';
import { Addresses } from '../../../models/addresses';
import { User } from '../../../models/user';
import { MatDialog } from '@angular/material/dialog';
import { AddUserDialogComponent } from '../add-user-dialog/add-user-dialog.component';

@Component({
  selector: 'app-company-add',
  standalone: false,
  templateUrl: './company-add.component.html',
  styleUrl: './company-add.component.css'
})

export class CompanyAddComponent {
  companyForm!: NgForm;
  company: Company = new Company();
  violations: any = {};
  loading: boolean = true;
  
  usersCompany: User[] = [];
  idCompany!: string;
  
  columndefs : any[] = ['email','fullName', 'rol'];
  
  constructor(private alerta: AlertaService,
              private companyService: CompanyService,
              private route: ActivatedRoute,
              private router: Router,
              private dialog: MatDialog
            ){}

 ngOnInit(): void {
   this.route.paramMap.subscribe(params => {
      let id : string = (params.get('id') || '');
      if(id === ''){
        //this.title = 'Agregar Empresa';
        this.loading = false;
      }else{
        //this.title = 'Editar Empresa';
        this.idCompany = id;
        this.companyService.findCompanyById(id).subscribe({
          next: (company) =>{
            //console.log(company);
           //this.company = company;
           this.violations = {};
           this.company = JSON.parse(JSON.stringify(company));
           if(this.company.addresses == null){
            this.company.addresses = new Addresses();
           }
           this.loading = false;
          }
        });
        this.companyService.findUsersOfCompany( id ).subscribe({
          next: (usersCompany) =>{
            this.usersCompany = usersCompany;
          }
        });
      }
    });
  }

  onSubmit(companyForm: NgForm): void {
    this.loading = true;
    this.companyForm = companyForm;
    if(this.company.id === '' || this.company.id == undefined){
      this.companyService.createCompany(this.company).subscribe({
          next: (pageable) => {
          this.alerta.correct("Empresa Registrada correctamente.");
          this.loading = false;
          this.router.navigate(['/companies']);
        },error: (err) => {
          //console.error('Error al agregar Empresa', err);
          if(err.status == 400) {
            this.violations = this.violationsToObject(err.error.parameterViolations);
            this.showViolations();
            this.alerta.information("Favor de completar el formulario");
          }else{
            this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
          }
          this.loading = false;
        }
      });
    }else{
      this.companyService.updateCompany(this.company.id, this.company).subscribe({
          next: (pageable) => {
          this.alerta.correct("Registro Actualizado correctamente.");
          this.loading = false;
          this.router.navigate(['/companies']);
        },error: (err) => {
          //console.error('Error al agregar Empresa', err);
          if(err.status == 400) {
            this.violations = this.violationsToObject(err.error.parameterViolations);
            this.showViolations();
            this.alerta.information("Favor de completar el formulario");
          }else{
            this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
          }
          this.loading = false;
        }
      });
    }
  } 


  violationsToObject(violationsList: []): any {
    return violationsList.reduce((obj: { [x: string]: any; }, item: { path: string; message: any; }) => {
        obj[item.path.slice(item.path.indexOf('.') + 1)] = item.message;
        return obj;
    }, {});
  };
  showViolations(){
    if(this.companyForm){
      Object.keys(this.companyForm.controls).forEach(controlName => {
        const control = this.companyForm.controls[controlName];
        if (this.violations[controlName]) {
          control.setErrors({ backend: true }); // Marca error
        }
      });
    }
  }
  getRoles(row: any): string {
    return row?.roles?.map((r: any) => r.description).join(', ') ?? '';
  }

  openAddUser(): void {
    this.dialog.open(AddUserDialogComponent, {
      width: '400px',
      disableClose: true,
      data: {
        idCompany: this.idCompany
      }
    });
  }

}